import { useSyncExternalStore } from 'react';

import {
  getActiveRunCount,
  isChatRunActive,
  subscribeChatRuns,
} from './chatRunTracker';

export function useTrackedChatRun(conversationId: string | null): boolean {
  return useSyncExternalStore(subscribeChatRuns, () =>
    conversationId ? isChatRunActive(conversationId) : false
  );
}

export function useAnyChatRunning(): number {
  return useSyncExternalStore(subscribeChatRuns, getActiveRunCount);
}
